module.exports = __webpack_public_path__ + "static/media/gray_11_3.8726de20.jpg";